import { ACTION } from './projects_actions';
import {
  list_reducer,
  add_reducer,
  update_reducer,
  delete_reducer,
  add_to_list_reducer,
  delete_in_list_reducer,
} from '../reducers';

const initialState = {
  objects: {},
  orderedIds: [],
  loading: false,
  editing: false,
  creating: false,
  uploading: false,
  exporting: false,
  isSummaryExporting: false,
  reportUrl: null,
  summaryReport: null,
  errorMessage: null,
};

export default (state = initialState, action) => {
  const PROJECT_IMGS = 'images';

  switch (action.type) {
    case `${ACTION.LIST}_PENDING`:
      return {
        ...state,
        loading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST}_FULFILLED`:
      return {
        ...state,
        ...list_reducer(state, action),
        loading: false,
      };
    case `${ACTION.LIST}_REJECTED`:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.GET}_PENDING`:
      return {
        ...state,
        loading: true,
        errorMessage: null,
      };
    case `${ACTION.GET}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        loading: false,
        errorMessage: null,
      };
    case `${ACTION.GET}_REJECTED`:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.EDIT}_PENDING`:
      return {
        ...state,
        editing: true,
        errorMessage: null,
      };
    case `${ACTION.EDIT}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        editing: false,
      };
    case `${ACTION.EDIT}_REJECTED`:
      return {
        ...state,
        editing: false,
        errorMessage: action.payload,
      };
    case `${ACTION.CREATE}_PENDING`:
      return {
        ...state,
        creating: true,
        errorMessage: null,
      };
    case `${ACTION.CREATE}_FULFILLED`:
      return {
        ...state,
        ...add_reducer(state, action),
        creating: false,
      };
    case `${ACTION.CREATE}_REJECTED`:
      return {
        ...state,
        creating: false,
        errorMessage: action.payload,
      };
    case `${ACTION.DELETE}_PENDING`:
      return {
        ...state,
        deleting: true,
        errorMessage: null,
      };
    case `${ACTION.DELETE}_FULFILLED`:
      return {
        ...state,
        ...delete_reducer(state, action),
        deleting: false,
        errorMessage: null,
      };
    case `${ACTION.DELETE}_REJECTED`:
      return {
        ...state,
        deleting: false,
        errorMessage: action.payload,
      };

    case `${ACTION.REMOVE_IMAGE}_PENDING`:
      return {
        ...state,
        deleting: true,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_IMAGE}_FULFILLED`:
      return {
        ...state,
        ...delete_in_list_reducer(state, action.payload.project_id, action.payload.id, PROJECT_IMGS),
        deleting: false,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_IMAGE}_REJECTED`:
      return {
        ...state,
        deleting: false,
        errorMessage: action.payload,
      };

    case `${ACTION.UPLOAD_IMAGE}_PENDING`:
      return {
        ...state,
        uploading: true,
        errorMessage: null,
      };
    case `${ACTION.UPLOAD_IMAGE}_FULFILLED`:
      return {
        ...state,
        ...add_to_list_reducer(state, action.payload.project_id, action.payload, PROJECT_IMGS),
        uploading: false,
        errorMessage: null,
      };
    case `${ACTION.UPLOAD_IMAGE}_REJECTED`:
      return {
        ...state,
        uploading: false,
        errorMessage: action.payload,
      };

    case `${ACTION.EXPORT_REPORT}_PENDING`:
      return {
        ...state,
        exporting: true,
        errorMessage: null,
      };
    case `${ACTION.EXPORT_REPORT}_FULFILLED`:
      return {
        ...state,
        exporting: false,
      };
    case `${ACTION.EXPORT_REPORT}_REJECTED`:
      return {
        ...state,
        exporting: false,
        errorMessage: action.payload,
      };

    case `${ACTION.EXPORT_SUMMARY_REPORT}_PENDING`:
      return {
        ...state,
        isSummaryExporting: true,
        errorMessage: null,
      };
    case `${ACTION.EXPORT_SUMMARY_REPORT}_FULFILLED`:
      return {
        ...state,
        summaryReport: action.payload,
        isSummaryExporting: false,
      };
    case `${ACTION.EXPORT_SUMMARY_REPORT}_REJECTED`:
      return {
        ...state,
        isSummaryExporting: false,
        errorMessage: action.payload,
      };

    case ACTION.CLEAR_ERROR:
      return {
        ...state,
        errorMessage: null,
      };
    case `${ACTION.EDIT_BUILDING}_PENDING`:
      return {
        ...state,
        editing_building: true,
        errorMessage: null,
      };
    case `${ACTION.EDIT_BUILDING}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        editing_building: false,
      };
    case `${ACTION.EDIT_BUILDING}_REJECTED`:
      return {
        ...state,
        editing_building: false,
        errorMessage: action.payload,
      };
    case `${ACTION.CREATE_BUILDING}_PENDING`:
      return {
        ...state,
        creating_building: true,
        errorMessage: null,
      };
    case `${ACTION.CREATE_BUILDING}_FULFILLED`:
      return {
        ...state,
        ...add_to_list_reducer(state, action.payload.project_id, action.payload, 'buildings'),
        creating_building: false,
      };
    case `${ACTION.CREATE_BUILDING}_REJECTED`:
      return {
        ...state,
        creating_building: false,
        errorMessage: action.payload,
      };
    case `${ACTION.DELETE_BUILDING}_PENDING`:
      return {
        ...state,
        deleting_building: true,
        errorMessage: null,
      };
    case `${ACTION.DELETE_BUILDING}_FULFILLED`:
      return {
        ...state,
        ...delete_reducer(state, action),
        deleting_building: false,
        errorMessage: null,
      };
    case `${ACTION.DELETE_BUILDING}_REJECTED`:
      return {
        ...state,
        deleting_building: false,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/projects/projects_reducers.js